const commentSortingOptions = (canModerate = false) => {
  const options = [
    { label: 'Datum nieuw', value: 'Datum nieuw', direction: 'down' },
    { label: 'Datum oud', value: 'Datum oud', direction: 'up' },
    { label: 'Meeste kudos', value: 'Meeste kudos', direction: 'down' },
    { label: 'Minste kudos', value: 'Minste kudos', direction: 'up' },
    { label: 'Reaguurder A-Z', value: 'Reaguurder A-Z', direction: 'down' },
    { label: 'Reaguurder Z-A', value: 'Reaguurder Z-A', direction: 'up' },
    canModerate && { label: 'Moderator', value: 'Moderator view', direction: 'down' },
  ];
  return options.filter((i) => i !== null && i !== false);
};

const commentsSortings = (list, sorting) => {
  const listArray = list || [];
  switch (sorting) {
    case 'Datum nieuw':
      return [...listArray.sort((a, b) => (a.id < b.id ? 1 : -1))];
    case 'Datum oud':
      return [...listArray.sort((a, b) => (a.id > b.id ? 1 : -1))];
    case 'Meeste kudos':
      return [...listArray.sort((a, b) => (a.kudos_count <= b.kudos_count ? 1 : -1))];
    case 'Minste kudos':
      return [...listArray.sort((a, b) => (a.kudos_count >= b.kudos_count ? 1 : -1))];
    case 'Reaguurder A-Z':
      return [
        ...listArray.sort((a, b) => (a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1)),
      ];
    case 'Reaguurder Z-A':
      return [
        ...listArray.sort((a, b) => (a.username.toLowerCase() < b.username.toLowerCase() ? 1 : -1)),
      ];
    case 'Moderator view': {
      const commentsChildCommentsArray = [
        ...list.map((comment) => ({
          ...comment,
          child_comments:
            comment.child_comments && comment.child_comments.length > 0
              ? [...comment.child_comments.sort((a, b) => (a.id > b.id ? 1 : -1))]
              : [],
          moderation_sort_date:
            comment.child_comments && comment.child_comments.length > 0
              ? comment.child_comments.sort((a, b) => (a.id < b.id ? 1 : -1))[0].creation_datetime
              : comment.creation_datetime,
        })),
      ];
      return [
        ...commentsChildCommentsArray.sort((a, b) =>
          a.moderation_sort_date < b.moderation_sort_date ? 1 : -1,
        ),
      ];
    }
  }
};

const searchSortings = [
  { label: 'Nieuwste', value: 'date%2B', direction: 'down' },
  { label: 'Oudste', value: 'date-', direction: 'up' },
  { label: 'Meeste kudos', value: 'kudos%2B', direction: 'down' },
  { label: 'Minste kudos', value: 'kudos-', direction: 'up' },
  { label: 'Relevantie', value: 'relevance', direction: 'down' },
];

export { commentSortingOptions, commentsSortings, searchSortings };
